//Document ready
$(document).ready(function() {
	videoBlockIframe();
	setThumbnail();
	videoPlay();
});

//Functions
//Iframes stuff
function videoBlockIframe() {
	$(".video-block iframe").each(function() {
		$(this)
			.addClass("embed-responsive-item")
			.wrap('<div class="embed-responsive embed-responsive-16by9"></div>');
		$(this).removeAttr("width");
		$(this).removeAttr("height");
	});
}

//Video play
function videoPlay() {
	$(".video-block .btn-play").click(function() {
		$(this)
			.siblings(".video-thumbnail")
			.remove();

		$(this)
			.siblings(".embed-responsive")
			.children("iframe")
			.attr(
				"src",
				"https://www.youtube.com/embed/" +
					$(this)
						.closest(".video-block")
						.attr("data-video-id") +
					"?autoplay=1"
			);

		$(this).remove();
	});
}

//Set thumbanil
function setThumbnail() {
	$(".video-thumbnail").each(function() {
		$(this).attr(
			"src",
			"https://img.youtube.com/vi/" +
				$(this)
					.closest(".video-block")
					.attr("data-video-id") +
				"/maxresdefault.jpg"
		);
	});
}
